import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { SessionCandidatesView } from '@/features/linkedin-sales-navigator/components/session-candidates-view'

function JobResultsPage() {
  const { jobId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <>
      <Header fixed>
        <div className='flex items-center gap-4'>
          <Button
            variant='ghost'
            size='icon'
            onClick={() => navigate({ to: '/linkedin/sales-navigator' })}
          >
            <ArrowLeft className='size-5' />
          </Button>
          <div className='flex-1'>
            <h1 className='text-2xl font-display font-bold'>Session Details</h1>
            <p className='text-sm text-muted-foreground'>
              View scraped candidates
            </p>
          </div>
        </div>
      </Header>

      <Main fixed className='flex flex-1 flex-col overflow-hidden p-0'>
        <SessionCandidatesView sessionId={jobId} />
      </Main>
    </>
  )
}

export const Route = createFileRoute(
  '/_authenticated/linkedin/sales-navigator/$jobId/'
)({
  component: JobResultsPage,
})
